<template>
    <div class="create-contract create-term-letter">
        <transition name="dialogfade">
            <k-dialog v-if="showDialog" class="default__dialog create-contract-dialog create-term-letter-dialog">
                <div class="icon__container">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <div class="header__container">
                    <svg viewBox="0 0 300 35" x="0px" y="0px" xml:space="preserve" fill="none" xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 300 35;"><path fill-rule="evenodd" class="icon__top-bar" clip-rule="evenodd" d="M290,21.74H169.3a19.32,19.32,0,0,1-38.64,0H10c-5.52,0-10,2.53-10,5.66V50H300V27.4C300,24.27,295.52,21.74,290,21.74Z" transform="translate(0 -21.74)" fill="#D4B139"></path></svg>
                </div>
                <div class="create-contract__header">
                    <h1 class="dialog--title">Create Contract Termination Letter</h1>
                </div>
                <div class="upsert-item__container create-contract">
                    <section class="upsert-item__section">
                        <div class="input__row pair letter-date__row">
                            <label class="input__label">
                                Letter Date
                                <k-datepicker v-model="termLetter.dateOfLetter"></k-datepicker>
                            </label>
                            <label class="input__label">
                                Player Name
                                <k-input v-model="termLetter.playerName" />
                            </label>
                        </div>

                        <h2 class="upsert-item__section--title">Agent Information</h2>
                        <div class="input__row pair">
                            <label class="input__label">
                                Agent First Name
                                <k-input v-model="termLetter.agentFirstName" />
                            </label>
                            <label class="input__label">
                                Agent Last Name
                                <k-input v-model="termLetter.agentLastName" />
                            </label>
                        </div>

                        <h2 class="upsert-item__section--title">Agency Information</h2>
                        <div class="input__row pair">
                            <label class="input__label">
                                Agency Name
                                <k-input v-model="termLetter.agencyName" />
                            </label>
                        </div>
                        <div class="input__row pair">
                            <label class="input__label">
                                Agency Street Address
                                <k-input v-model="termLetter.agencyStreetAddress" />
                            </label>
                            <label class="input__label">
                                Agency City
                                <k-input v-model="termLetter.agencyCity" />
                            </label>
                        </div>
                        <div class="input__row trio">
                            <label class="input__label">
                                Agency State/Province
                                <k-input v-model="termLetter.agencyState" />
                            </label>
                            <label class="input__label">
                                Agency Zip/Postal Code
                                <k-input v-model="termLetter.agencyZipCode" />
                            </label>
                            <label class="input__label">
                                Agency Country
                                <k-input v-model="termLetter.agencyCountry" />
                            </label>
                        </div>
                    </section>
                    <k-action-bar>
                        <k-button class="item-save__btn" @click.prevent="onSaveClicked" title="Generate Letter">Generate Letter</k-button>
                        <k-button class="item-cancel__btn" @click="onCloseDialog" title="Close">Close</k-button>
                    </k-action-bar>
                </div>

                <div class="loader-container" v-if="isLoading">
                    <k-loader :size="'large'" :type="'infinite-spinner'"></k-loader>
                </div>
            </k-dialog>
        </transition>

        <transition name="dialogfade">
            <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
                <p class="error-dialog__msg">{{ errorMsg }}</p>
            </k-dialog>
        </transition>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { Button } from "@progress/kendo-vue-buttons";
    import { Input } from "@progress/kendo-vue-inputs";
    import { DatePicker } from '@progress/kendo-vue-dateinputs';
    import { Loader } from "@progress/kendo-vue-indicators";

    import cloneDeep from 'lodash.clonedeep';

    import auth from '../authConfig';
    import apiService from '../api/api.service.js';

    export default {
        name: 'createTermLetterDialog',
        props: ['showDialog'],
        emits: ['dialogclosed'],
        data() {
            return {
                errorMsg: '',
                errorTitle: '',
                isLoading: false,
                showErrorDialog: false,
                termLetter: {},
                termLetterModel: {
                    dateOfLetter: new Date(),
                    letterDate: null,
                    agentFirstName: null,
                    agentLastName: null,
                    agencyName: null,
                    agencyStreetAddress: null,
                    agencyCity: null,
                    agencyState: null,
                    agencyZipCode: null,
                    agencyCountry: null,
                    playerName: null
                }
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.resetDefaults();
                }
            }
        },
        methods: {
            async generateTerminationLetter() {
                let self = this;
                self.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.CreateContractTerminationLetter(tokenResponse.accessToken, this.termLetter)
                    .then(res => {
                        self.openPDF(res.data.data);
                        self.isLoading = false;
                    }).catch(error => {
                        console.log(error);
                        self.onRequestError('An Error Occurred', error?.response?.data?.message);
                    });
            },
            onCloseDialog() {
                this.$emit('dialogclosed');
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.showErrorDialog = true;
            },
            onSaveClicked() {
                this.termLetter.letterDate = this.termLetter.dateOfLetter.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
                
                this.generateTerminationLetter();
            },
            openPDF(src) {
                if (!src) return;
                
                let pdfWindow = window.open("");

                setTimeout(() => {
                    if (pdfWindow.document) {
                        pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(src) + "'></iframe>");
                    }
                }, 2000)
            },
            resetDefaults() {
                this.termLetter = cloneDeep(this.termLetterModel);
                this.isLoading = false;
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if(!this.showErrorDialog) {
                    this.errorTitle = '';
                    this.errorMsg = '';
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-loader': Loader,
            'k-action-bar': DialogActionsBar,
            'k-button': Button,
            'k-datepicker': DatePicker,
            'k-input': Input

        }
    }
</script>

<style>
    @import '/src/assets/css/defaultUpsertStyles.css';
    @import '/src/assets/css/createContractDialog.css';
    @import '/src/assets/css/createTermLetterDialog.css';
</style>